export default __webpack_public_path__ + "static/media/sv44_kr_star_b1.54877fab.mp3";